export default __webpack_public_path__ + "static/wuiAndFigma-a2f525e091b34f59aa1bf0ffb28004f5.webp";